import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CSidebar, CSidebarBrand, CSidebarNav } from '@coreui/react';

import logo from '../assets/images/logo4.png';
import logo_mini from '../assets/images/logo_mini.png';
import { ApplicationState } from '../store';
import { useTranslation } from 'react-i18next';
import { AuthUser, getCurrentUser } from '@aws-amplify/auth';
const TheSidebar: React.FC = () => {
  const dispatch = useDispatch();
  const show = useSelector((state: ApplicationState) => state.sidebarShow);
  const state_lang = useSelector((state: ApplicationState) => state.lang);
  const [t, i18n] = useTranslation();
  const [currentUser, setCurrentUser] = useState<AuthUser | null>(null);
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const user = await getCurrentUser();
        setCurrentUser(user);
      } catch (error) {
        setCurrentUser(null);
      }
    };
    fetchUser();
  }, []);
  return (
    <CSidebar
      show={show}
      onShowChange={(val: boolean | '' | 'responsive' | undefined) =>
        dispatch({ type: 'set', sidebarShow: val })
      }
      className="sed-om-sidebar"
    >
      <CSidebarBrand className="d-md-down-none sed-om-sidebar-brand" to="/">
        <div className="sed-om-sidebar-logo-wrapper c-sidebar-brand-full">
          <div className="logo">
            <img src={logo} alt={t('自然電力')} />
          </div>
          <p className="site">{t('取引支援システム(Demo)')}</p>
          {currentUser?.signInDetails?.['loginId'] && <p className="name">{currentUser?.signInDetails?.['loginId']}</p>}
        </div>

        <div className="sed-om-sidebar-logo-wrapper c-sidebar-brand-minimized">
          <div className="logo">
            <img src={logo} alt={t('自然電力')} />
          </div>
        </div>
      </CSidebarBrand>

      <CSidebarNav />

      {/* <CSidebarMinimizer className="c-d-md-down-none"/> */}
    </CSidebar>
  );
};

export default React.memo(TheSidebar);
